import type { DataTableColumn } from '@/components/custom/erp';
import type { NhaCungCap } from '@/types/schemas';

export const getTableColumns = (handleOpenView: (row: NhaCungCap) => void): DataTableColumn<NhaCungCap>[] => [
  {
    field: 'ma_kh',
    headerName: 'Mã nhà cung cấp',
    width: 150,
    renderCell: params => (
      <button className='hover:text-blue-500 hover:underline' onClick={() => handleOpenView(params.row)}>
        {params.value || params.row.customer_code}
      </button>
    )
  },
  {
    field: 'ten_kh',
    headerName: 'Tên nhà cung cấp',
    width: 220,
    renderCell: params => params.value || params.row.customer_name
  },
  {
    field: 'ma_so_thue',
    headerName: 'Mã số thuế',
    width: 120,
    renderCell: params => params.value || params.row.tax_code
  },
  { field: 'dia_chi', headerName: 'Địa chỉ', width: 200, renderCell: params => params.value || params.row.address },
  {
    field: 'ma_nvbh',
    headerName: 'Mã nhân viên',
    width: 120,
    renderCell: params => params.value || params.row.sales_rep_data?.ma_nhan_vien
  },
  {
    field: 'cong_no_pthu',
    headerName: 'Công nợ p/thu',
    width: 150,
    align: 'right',
    renderCell: params => params.value || params.row.cong_no_pthu
  },
  {
    field: 'nh_kh1',
    headerName: 'Nhóm 1',
    width: 120,
    renderCell: params => params.value || params.row.customer_group1_data?.ma_nhom
  },
  {
    field: 'nh_kh2',
    headerName: 'Nhóm 2',
    width: 120,
    renderCell: params => params.value || params.row.customer_group2_data?.ma_nhom
  },
  {
    field: 'nh_kh3',
    headerName: 'Nhóm 3',
    width: 120,
    renderCell: params => params.value || params.row.customer_group3_data?.ma_nhom
  },
  { field: 'dien_thoai', headerName: 'Điện thoại', width: 120, renderCell: params => params.value || params.row.phone },
  { field: 'e_mail', headerName: 'Thư', width: 120, renderCell: params => params.value || params.row.email }
];
